import { Button, Checkbox, FormControlLabel, Grid, Typography } from "@mui/material";
import { Form, Formik } from "formik";
import { useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getDatosCIUOPuesto } from "../../../../redux/actions/resolucion";
import FormikAutocomplete from "../../../commons/formik/FormikAutocomplete";
import FormikTextField from "../../../commons/formik/FormikTextField";
import CharactersCounterLabel from "../../../commons/labels/CharactersCounterLabel";
import RequeridoLabel from '../../../commons/labels/RequeridoLabel';
import PuestosFormContainer from "../../../commons/puestos/PuestosFormContainer";
import TabsWithErrors, { TabPanel } from "../../../commons/tab/tabWithError/TabsWithErrors";
import ElementosDeProteccionTabContainer from './elementosDeProteccion/ElementosDeProteccionTabContainer';
import MedidasPreventivasTabContainer from "./medidasPreventivas/MedidasPreventivasTabContainer";
import { puestosAsociadosValidation } from "./puestosValidations";

const PuestosAsociadosForm = ({
  initialValues,
  onSubmit,
  onCancel,
  sustancias,
}) => {
  const dispatch = useDispatch();
  const ref = useRef();
  const [tabIndex, setTabIndex] = useState(0);
  const puestosAsociadosASustancias = useSelector((state) => state.resolucion.postResolucion.puestos);
  const idDependenciaEmpleador = useSelector(
    (state) => state.resolucion.searchedEstablecimiento
  );

  const handleTabChange = (event, newIndex) => {
    setTabIndex(newIndex);
  };
  return (
    <Formik
      initialValues={initialValues}
      validationSchema={puestosAsociadosValidation(puestosAsociadosASustancias)}
      onSubmit={onSubmit}
    >
      {({ values, setFieldValue }) => (

        <Form >
          <Typography ref={ref} variant="h6" style={{ paddingLeft: "20px" }}>
            Agregar/Editar Puesto Asociado a Sustancia
          </Typography>
          <div style={{ padding: "10px" }}>
            <Grid container spacing={5}>
              <Grid container item xs={5} spacing={2}>
                <Grid item xs={12}>
                  <PuestosFormContainer
                    name="puesto"
                    add
                    idDependenciaEmpleador={idDependenciaEmpleador}
                    callBack={(e) => {
                      setFieldValue('nombrePuesto', e?.nombre ?? "");
                      if (e?.id) {
                        dispatch(getDatosCIUOPuesto(e.id)).then((res) => {
                          setFieldValue(
                            "descripcionActividades",
                            res.value.data.descripcion ?? ""
                          );
                        })
                      }
                    }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <FormikAutocomplete
                    name="sustancia"
                    label="Sustancia"
                    options={sustancias}
                    fullWidth
                  />
                </Grid>
              </Grid>
              <Grid container item xs={7} style={{ marginTop: 15 }} spacing={2}>
                <Grid container item xs={12}>
                  <Grid item xs={6}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={values.informaRiesgos}
                          onChange={() =>
                            setFieldValue(
                              "informaRiesgos",
                              !values.informaRiesgos
                            )
                          }
                        />
                      }
                      label="Informa sobre los riesgos a los empleados"
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={values.poseeCapacitaciones}
                          onChange={() =>
                            setFieldValue(
                              "poseeCapacitaciones",
                              !values.poseeCapacitaciones
                            )
                          }
                        />
                      }
                      label="Posee Capacitaciones sobre los riesgos"
                    />
                  </Grid>
                </Grid>

                <Grid container item xs={12} spacing={2}>
                  <Grid item xs={6}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={values.entregaProteccion}
                          onChange={() =>
                            setFieldValue(
                              "entregaProteccion",
                              !values.entregaProteccion
                            )
                          }
                        />
                      }
                      label="La empresa entrega elementos de protección"
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={values.licenciasEspeciales}
                          onChange={() =>
                            setFieldValue(
                              "licenciasEspeciales",
                              !values.licenciasEspeciales
                            )
                          }
                        />
                      }
                      label="La empresa otorga licencias especiales"
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            {/* Campos de texto con padding */}
            <Grid container spacing={3} sx={{ marginTop: 2 }}>
              {" "}
              {/* Espaciado de grillas reducido */}
              <Grid item xs={6}>
                <FormikTextField
                  name="descripcionActividades"
                  label="Descripción de Actividades"
                  multiline
                  maxRows={15}
                  minRows={2}
                  fullWidth
                  filled
                />
                <CharactersCounterLabel
                  value={values.descripcionActividades}
                  maxCharacters={200}
                />
              </Grid>
              <Grid item xs={6}>
                <FormikTextField
                  name="descripcionEstudios"
                  label="Descripción de Estudios y Reemplazo"
                  multiline
                  maxRows={15}
                  minRows={2}
                  fullWidth
                  filled
                />
                <CharactersCounterLabel
                  value={values.descripcionEstudios}
                  maxCharacters={200}
                />
              </Grid>
              <Grid item xs={12} >
                <RequeridoLabel text="Complete los datos de protección o medidas preventivas si corresponde. De lo contrario, presione guardar"
                  labelContainerStyle={{ margin: 8 }} />
              </Grid>
              <Grid item xs={2}>
                <TabsWithErrors
                  handleTabChange={handleTabChange}
                  tabIndex={tabIndex}
                  tabs={[
                    { label: "El. DE PROTECCIÓN", id: "elementosDeProteccion" },
                    { label: "MEDIDAS PREVENTIVAS", id: "medidasPreventivas" },
                  ]}
                />
              </Grid>
              <Grid item xs={10}>
                <TabPanel value={tabIndex} index={0}>
                  <ElementosDeProteccionTabContainer />
                </TabPanel>
                <TabPanel value={tabIndex} index={1}>
                  <MedidasPreventivasTabContainer />
                </TabPanel>
              </Grid>
            </Grid>

            <div
              style={{
                margin: "10px",
                display: "flex",
                justifyContent: "flex-end",
              }}
            >
              <Button
                onClick={onCancel}
                // color="default"
                style={{ marginRight: "10px" }}
              >
                Cancelar
              </Button>
              <Button type="submit" variant="contained">
                Guardar
              </Button>
            </div>
          </div>
        </Form>

      )}
    </Formik>
  );
};

export default PuestosAsociadosForm;
